import { SetListenerIfc } from '../SetListenerIfc';
import { BitBoardEntity } from '../../utils/BitBoardEntity';

export class SetDispatcher implements SetListenerIfc{
		listeners:Array<SetListenerIfc>;
	
		beCount:number = 0;
		
		constructor() 
		{
			this.listeners = new Array<SetListenerIfc>();
		}
		
		isSetListener():boolean{
			return true;
		}

		protected validateNoActiveBatch():void{
			if( this.beCount != 0 ){
				throw new Error("Attempt to add listener inside batch!");
			}
		}
		protected validateBatch():void{
			if( this.beCount == 0 ){
				throw new Error("Attempt to modify set state outside of batch");
			}
		}
		
		public addListener( listener:SetListenerIfc ):void{
			this.validateNoActiveBatch();
			if( this.listeners.indexOf(listener) >= 0 ){
				throw new Error("Adding the same listener second time: " + listener);
			}
			this.listeners.push( listener );
		}
		
		public destruct():void{
			this.validateNoActiveBatch();
			this.listeners = null;
		}
		
		public removeListener(  listener:SetListenerIfc ):void{
			this.validateNoActiveBatch();
			let contains:number = this.listeners.indexOf( listener );
			if( contains < 0 ){
				throw new Error("Attempt to remove listene that is not added to this set! " + listener);
			}
			this.listeners.splice( contains, 1 );
		}
		
		public addRecord( record:number ):void {
			this.validateBatch();
			for ( let listener of this.listeners){
				listener.addRecord(record);
			}		
		}
		
		public addRecords( records:Array<number> ):void {
			this.validateBatch();
			for ( let listener of this.listeners){
				listener.addRecords(records);
			}		
		}
		
		public begin():void {
			this.beCount++;
			for ( let listener of this.listeners){
				listener.begin();
			}	
		}
		
		public end():void {
			this.beCount--;
			if( this.beCount < 0 ){
				throw new Error("Batch inconsistency, beCount below zero: " + this.beCount);		
			}		
			for ( let listener of  this.listeners){
				listener.end();
			}	
		}
		
		public deleteRecord( id:number ):void {
			this.validateBatch();
			for ( let listener of this.listeners){
				listener.deleteRecord(id);
			}		
		}
		
		public deleteRecords( id:Array<number> ):void {
			this.validateBatch();
			for ( let listener of this.listeners){
				listener.deleteRecords(id);
			}		
		}
		
		public reset():void {
			this.validateBatch();
			for ( let listener of this.listeners){
				listener.reset();
			}		
		}
		
		public cellsUpdated( cells:BitBoardEntity, id:number ):void {
			this.validateBatch();
			for ( let listener of this.listeners){
				listener.cellsUpdated(cells, id);
			}		
		}
		
	public setContainerMetaData( name:string, value:string ):void {
		this.validateBatch();
		for ( let listener of this.listeners){
			listener.setContainerMetaData(name, value);
		}
	}
	
	public setContainerMetaDatas( names:Array<string>, values:Array<string>):void {
		this.validateBatch();
		for ( let listener of this.listeners){
			listener.setContainerMetaDatas(names, values);
		}		
	}
	
	public removeContainerMetaDatas( names:Array<string> ):void {
		this.validateBatch();
		for ( let listener of this.listeners){
			listener.removeContainerMetaDatas(names);
		}
	}
	
	public removeMetaData( name:string ):void {
		this.validateBatch();
		for ( let listener of this.listeners){
			listener.removeMetaData(name);
		}
	}
}